import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import '@/App.css';
import { AuthProvider } from '@/context/AuthContext';
import Landing from '@/pages/Landing';
import AdminLogin from '@/pages/AdminLogin';
import AdminInquiries from '@/pages/AdminInquiries';
import AuthCallback from '@/pages/AuthCallback';

function AppRouter() {
  const location = useLocation();
  // Synchronously detect OAuth callback BEFORE normal routing
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin/inquiries" element={<AdminInquiries />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
